<template>
  <div>
    <div class="header-container pc-header" :class="{'relative':!isHome}">
      <header>
        <div class="header-left">
          <a href="/" :title="$t('menu.home')" class="logo-wrapper">
            <img src="../../../assets/img/logo_color.png" alt="mixmarvel-logo" />
          </a>
          <a
            :href="'/pdfViewer/web/viewer.html?file='+pdfUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="baipi-down"
            v-text="$t('download')"
            v-if="langobj.value != 'zh'"
          ></a>
        </div>
        <div class="header-right">
          <el-menu
            :default-active="activeIndex"
            class="menu"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="1">
              <a href @click.prevent="anchor('products')" v-text="$t('menu.products')"></a>
            </el-menu-item>
            <el-menu-item index="2">
              <a href @click.prevent="anchor('information')" v-text="$t('menu.information')"></a>
            </el-menu-item>
            <el-menu-item index="3">
              <a href @click.prevent="anchor('about')" v-text="$t('menu.about')"></a>
            </el-menu-item>
            <el-menu-item index="4">
              <a href @click.prevent="anchor('community')" v-text="$t('menu.joincommunity')"></a>
            </el-menu-item>
            <el-menu-item>
              <a href @click.prevent="showSubscribePopup('pc')" v-text="$t('menu.subscribe')"></a>
            </el-menu-item>
            <el-menu-item>
              <a href @click.prevent="showSubscribePopup('pc')" v-text="$t('menu.buy_mix')"></a>
              <div class="buy-mix-dropdown-box">
                <ul class="buy-mix-list">
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-link" href="https://www.bybit.com/en-US/trade/spot/MIX/USDT" target="_blank">Bybit</a>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-link" href="https://en.bithumb.com/trade/order/MIX_KRW" target="_blank">Bithumb</a>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-link" href="https://www.mexc.com/exchange/MIX_USDT" target="_blank">MEXC</a>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-tab" href="#">Gate.io</a>
                    <ul class="buy-mix-second-list">
                      <li class="buy-mix-second-list-item">
                        <a class="buy-mix-link" href="https://www.gate.io/trade/MIX_USDT" target="_blank">USDT</a>
                        <a class="buy-mix-link" href="https://www.gate.io/trade/MIX_ETH" target="_blank">ETH</a>
                      </li>
                    </ul>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-link" href="https://ascendex.com/en/cashtrade-spottrading/usdt/mix" target="_blank">AscendEX</a>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-tab" href="#">Hotbit</a>
                    <ul class="buy-mix-second-list">
                      <li class="buy-mix-second-list-item">
                        <a class="buy-mix-link" href="https://www.hotbit.io/exchange?symbol=MIX_USDT" target="_blank">USDT</a>
                        <a class="buy-mix-link" href="https://www.hotbit.io/exchange?symbol=MIX_BTC" target="_blank">BTC</a>
                      </li>
                    </ul>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-link" href="https://www.bitglobal.com/en-us/spot/trade?q=MIX-USDT" target="_blank">BitGlobal</a>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-link" href="https://pancakeswap.finance/info/token/0x398f7827dccbefe6990478876bbf3612d93baf05" target="_blank">PancakeSwap</a>
                  </li>
                  <li class="buy-mix-list-item">
                    <a class="buy-mix-link" href="https://app.uniswap.org/" target="_blank">Uniswap</a>
                  </li>
                </ul>
              </div>
            </el-menu-item>
          </el-menu>
          <div class="right-wrapper">
            <div class="pc-lang">
              <el-dropdown trigger="hover" @command="setLang">
                <span class="el-dropdown-link lang-selected">
                  {{langobj.label}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="pc-lang-dropdown">
                  <el-dropdown-item
                    v-for="item in languages"
                    :key="item.value"
                    :command="item"
                  >{{item.label}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!-- <div class="search-box">
            <div class="search-input-wrapper">
              <input
                type="text"
                :placeholder="$t('search')"
                v-model="keyword"
                class="search-input"
                @keyup.enter="search"
              />
              <i class="el-input__icon el-icon-search search-icon" @click="search"></i>
            </div>
            </div>-->
          </div>
        </div>
      </header>
    </div>
    <div class="header wap-header">
      <a href="/" class="home-link">
        <img class="logo" src="../../../assets/img/footer/logo_colorful.png" />
      </a>
      <div class="language-box">
          <span class="lang-btn" @click.stop="openLangMenu">
            {{langobj.label}}
            <i class="el-icon-arrow-down"></i>
          </span>
          <ul class="lang-list pop-up-box menu-popup-box">
            <li class="lang-item menu-popup-item" @click.stop="setLang(item)" v-text="item.label" v-for="item in languages" :key="item.value"></li>
          </ul>
      </div>
      <div class="menu">
          <span class="lang-btn" @click.stop="openMenu">
            <i class="menu-icon"></i>
          </span>
          <ul id="menu_list" class="pop-up-box menu-popup-box">
            <a v-if="langobj.value!='zh'" :href="this.pdfUrl" class="dropDownText menu-popup-item" v-text="$t('download')"></a>
            <a href class="dropDownText menu-popup-item" v-text="$t('menu.products')" @click.prevent="wapAnchor('wap_products')"></a>
            <a href class="dropDownText menu-popup-item" v-text="$t('menu.information')" @click.prevent="wapAnchor('wap_information')"></a>
            <a href class="dropDownText menu-popup-item" v-text="$t('menu.about')" @click.prevent="wapAnchor('wap_about')"></a>
            <a href class="dropDownText menu-popup-item" v-text="$t('menu.joincommunity')" @click.prevent="wapAnchor('wap_community')"></a>
            <a href class="dropDownText menu-popup-item" v-text="$t('menu.subscribe')" @click.prevent="showSubscribePopup('wap')"></a>
            <a href class="dropDownText menu-popup-item" v-text="$t('menu.buy_mix')" @click.prevent="showBuyMixPopup()"></a>
          </ul>
      </div>
    </div>
    <div v-if="isWapShowBuyMix" class="wap-buy-mix-popup">
      <div class="mask" @click="hideBuyMixPopup"></div>
      <div class="buy-mix-content-outer">
        <div class="buy-mix-title">Buy Mix</div>
        <div class="buy-mix-content-inner">
          <ul class="buy-mix-list">
            <li class="buy-mix-list-item">
              <a class="buy-mix-link" href="https://www.bybit.com/en-US/trade/spot/MIX/USDT" target="_blank">Bybit</a>
            </li>
            <li class="buy-mix-list-item">
              <a class="buy-mix-link" href="https://en.bithumb.com/trade/order/MIX_KRW" target="_blank">Bithumb</a>
            </li>
            <li class="buy-mix-list-item">
              <a class="buy-mix-link" href="https://www.mexc.com/exchange/MIX_USDT" target="_blank">MEXC</a>
            </li>
            <li class="buy-mix-list-item" @click="isShowGate=!isShowGate">
              <a class="buy-mix-tab" :class="{'active':isShowGate}" href="#">Gate.io</a>
              <ul v-if="isShowGate" class="buy-mix-second-list">
                <li class="buy-mix-second-list-item">
                  <a class="buy-mix-link" href="https://www.gate.io/trade/MIX_USDT" target="_blank">USDT</a>
                  <a class="buy-mix-link" href="https://www.gate.io/trade/MIX_ETH" target="_blank">ETH</a>
                </li>
              </ul>
            </li>
            <li class="buy-mix-list-item">
              <a class="buy-mix-link" href="https://ascendex.com/en/cashtrade-spottrading/usdt/mix" target="_blank">AscendEX</a>
            </li>
            <li class="buy-mix-list-item" @click="isShowHotBit=!isShowHotBit">
              <a class="buy-mix-tab" :class="{'active':isShowHotBit}" href="#">Hotbit</a>
              <ul v-if="isShowHotBit" class="buy-mix-second-list">
                <li class="buy-mix-second-list-item">
                  <a class="buy-mix-link" href="https://www.hotbit.io/exchange?symbol=MIX_USDT" target="_blank">USDT</a>
                  <a class="buy-mix-link" href="https://www.hotbit.io/exchange?symbol=MIX_BTC" target="_blank">BTC</a>
                </li>
              </ul>
            </li>
            <li class="buy-mix-list-item">
              <a class="buy-mix-link" href="https://www.bitglobal.com/en-us/spot/trade?q=MIX-USDT" target="_blank">BitGlobal</a>
            </li>
            <li class="buy-mix-list-item">
              <a class="buy-mix-link" href="https://pancakeswap.finance/info/token/0x398f7827dccbefe6990478876bbf3612d93baf05" target="_blank">PancakeSwap</a>
            </li>
            <li class="buy-mix-list-item">
              <a class="buy-mix-link" href="https://app.uniswap.org/" target="_blank">Uniswap</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from "../common/common";
import { getUrlParam } from "../../../assets/js/common";
import { subscribePost } from "../../../request/api";
export default {
  data() {
    return {
      isShowGate:false,
      isShowHotBit:false,
      isWapShowBuyMix:false,
      activeIndex: "1",
      languages: [
        {
          value: "zh",
          label: "简体中文"
        },
        {
          value: "en",
          label: "English"
        },
        {
          value: "kr",
          label: "한국어"
        }
      ],
      langobj: {},
      keyword: "",
      isHome: true,
      pdfUrl: ""
    };
  },
  inject: ["reload"],
  created() {
    this.initLanguage();
    var currentPath = this.$route.path;
    if (currentPath != "/") {
      this.isHome = false;
    }
  },
  methods: {
    openLangMenu(){
      $('.lang-list').toggleClass('show');
      $('#menu_list').removeClass('show');
    },
    openMenu(){
      $('.lang-list').removeClass('show');
      $('#menu_list').toggleClass('show');
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    setLang(obj) {
      this.$cookies.set("language", obj.value);
      this.langobj = obj;
      this.$i18n.locale = obj.value;
      document.title = this.$i18n.t('title')
      this.reload();
      if(!this.checkMask()){
        $('html').removeClass('gray');
      }
    },
    anchor(id) {
      //跳转到对应的section
      if (this.isHome) {
        var selector = "#" + id;
        var scrollH = $(selector).offset().top;
        $("html,body").animate({ scrollTop: scrollH - 70 }, 1000);
      } else {
        this.$cookies.set("anchor", id);
        window.location.href = "/";
      }
    },
    wapAnchor(id) {
      //跳转到对应的section
      if (this.isHome) {
        var scrollH = $("#" + id).offset().top;
        var oneVW = window.innerWidth/100;
        var paddingTop = 15 * oneVW;
        $("html,body").animate({ scrollTop: scrollH - paddingTop }, 1000);
      } else {
        this.$cookies.set("anchor", id);
        window.location.href = "/";
      }
    },
    search() {
      alert(this.keyword);
    },
    initLanguage() {
      // 初始化语言
      var _this = this;
      var lang = this.$cookies.get("language") || global.initLang;
      if (lang) {
        _this.languages.forEach(element => {
          if (element.value == lang) {
            _this.langobj = element;
            _this.$i18n.locale = lang;
            document.title = this.$i18n.t('title')
          }
        });
      } else {
        _this.langobj = this.languages[0];
      }

      if (lang == "zh") {
        this.pdfUrl =
          window.location.protocol +
          "//" +
          window.location.host +
          "/pdf/MIXMARVEL_whitepaper_cn.pdf";
          if(this.checkMask()){
            $('html').addClass('gray');
          }
      } else if (lang == "kr") {
        this.pdfUrl =
          window.location.protocol +
          "//" +
          window.location.host +
          "/pdf/MIXMARVEL_whitepaper_kr.pdf";
          if(this.checkMask()){
            $('html').addClass('gray');
          }
      } else {
        this.pdfUrl =
          window.location.protocol +
          "//" +
          window.location.host +
          "/pdf/MixMarvel_Whitepaper.pdf";
      }
    },
    showSubscribePopup(type){
      var _this = this,
      contentHtml='';
      contentHtml = `<div class="subscribeBox ${type||''}" id="subscribeBox">\
                      <div class="subscribeBg"></div>\
                      <div class="subscribePopup">\
                        <div class="subscribeClose" title="close"></div>\
                        <div class="subscribeTitle">${_this.$i18n.t('subscribe.subscribe_title')}</div>\
                        <div class="subscribeContent">\
                        <input type="email" name="email" id="subscribeInput" class="subscribeInput" placeholder="${_this.$i18n.t('subscribe.subscribe_placeholder')}">\
                        <div class="subscribeBtn">${_this.$i18n.t('subscribe.subscribe_btn_text')}</div>\
                        </div>\
                        <div class="subscribeTips"></div>\
                      </div>\
                    </div>`
      $("body").append(contentHtml);
      var $subscribeBox = $('#subscribeBox')
      $subscribeBox.find('.subscribeClose').click(function () {
        _this.subscribeClose()
      })
      $subscribeBox.find('.subscribeBtn').click(function () {
        _this.subscribeSubmit()
      })
    },
    showBuyMixPopup(){
      this.isWapShowBuyMix = true
    },
    hideBuyMixPopup(){
      this.isWapShowBuyMix = false
    },
    subscribeClose(){
      var $subscribeBox = $('#subscribeBox')
      $subscribeBox.remove()
    },
    subscribeSubmit(){
      var _this = this;
      var email = $('#subscribeInput').val();
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (!!!email&&email!==0) {
        $('.subscribeTips').text(_this.$i18n.t('subscribe.empty_tips'));
        return
      }
      if (!reg.test(email)) {
        $('.subscribeTips').text(_this.$i18n.t('subscribe.incorrect_tips'));
        return
      }
      subscribePost({
        email: email,
      })
      .then(res => {
        var currentLang = _this.langobj.value
        if (res.success) {
          $('.subscribeTips').text(_this.$i18n.t('post_code.subscribe_success'));
          setTimeout(function () {
            _this.subscribeClose();
          },3000)
        }else{
          if (res.code) {
            $('.subscribeTips').text(_this.$i18n.t('post_code.'+res.code));
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
    },
    checkMask(){
      var nowTime = new Date(),
          startTime = new Date('2020/04/04 00:00:00'),
          endTime = new Date('2020/04/04 23:59:59');
      if (nowTime.getTime()>startTime.getTime() && nowTime.getTime()<endTime.getTime() && this.langobj.value=='zh') {
        return true;
      }else{
        return false
      }
    }
  },
  mounted() {
    var _this = this;
    this.$nextTick(function() {
      var anchor = this.$cookies.get("anchor");
      if (anchor != "false" && anchor != null && anchor != "null") {
        if (window.innerWidth >= 800) {
          setTimeout(function() {
            _this.anchor(anchor);
            _this.$cookies.set("anchor", null);
          }, 500);
        } else {
          setTimeout(function() {
            _this.wapAnchor(anchor);
            _this.$cookies.set("anchor", null);
          }, 500);
        }
      }
    });
  }
};
</script>

<style>
html.gray{
  -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#grayscale");
    filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
}
</style>



// WEBPACK FOOTER //
// src/components/pc/template/HeaderCommon.vue